import { action, observable, observe } from "mobx";

import MODAL_VIEW_TYPES from "../../constants/modalViewTypes";

const withHomeClaimModal = BaseClass =>
  class extends BaseClass {
    @observable isModalOpen = false;
    @observable modalView = MODAL_VIEW_TYPES.personalInfo;

    setHomeClaimModalObservers() {
      observe(this, "isModalOpen", ({ newValue: isModalOpen }) => {
        if (isModalOpen) {
          this.analyticsService.sendModalOpen();
        }
      });
    }

    @action.bound
    setModalOpen(value) {
      this.isModalOpen = value;
    }

    @action.bound
    openModal() {
      this.setModalOpen(true);
    }

    @action.bound
    closeModal() {
      this.setModalOpen(false);
      this.setModalView(MODAL_VIEW_TYPES.personalInfo);
    }

    @action.bound
    setModalView(viewType) {
      this.modalView = viewType;
    }
  };

export default withHomeClaimModal;
